import { useExamEventDetails } from '@exam-center/exam-event-management';
import { GetExamEventByIdDocument, useUpdateExamEventMutation } from '@exam-center/graphql';
import {
  DeleteOutlineIcon,
  EllipsisText,
  MoreMenuIconButton,
  type GridColDef,
} from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

function ProctorListMoreActionMenu(props: Readonly<{ id: string }>) {
  const { id } = props;

  const { showSnackbar } = useSnackbar();
  const { examEvent } = useExamEventDetails();

  const [updateExamEvent] = useUpdateExamEventMutation({
    onCompleted: () => {
      showSnackbar({ message: 'ลบผู้คุมสอบเรียบร้อยแล้ว', variant: 'success' });
    },
    onError: () => {
      showSnackbar({ message: 'ไม่สามารถลบผู้คุมสอบได้', variant: 'error' });
    },
    awaitRefetchQueries: true,
    refetchQueries: [GetExamEventByIdDocument],
  });

  const onClick = async () => {
    const updatedProctorIds = (examEvent.proctors ?? [])
      .filter((proctor) => proctor.id !== id)
      .map((proctor) => proctor.id);

    await updateExamEvent({
      variables: {
        updateExamEventInput: {
          id: examEvent.id,
          data: {
            proctorIds: updatedProctorIds,
          },
        },
      },
    });
  };

  return (
    <MoreMenuIconButton
      options={[
        {
          label: 'ลบผู้คุมสอบ',
          icon: <DeleteOutlineIcon sx={{ color: (theme) => theme.palette.error.main }} />,
          sx: (theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.body1.fontSize,
          }),
          onClick: async () => await onClick(),
        },
      ]}
    />
  );
}

export const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'ชื่อ-นามสกุล',
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      return <EllipsisText>{params.value}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    sortable: false,
    width: 240,
    renderCell: (params) => {
      return <EllipsisText>{params.value}</EllipsisText>;
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    sortable: false,
    width: 48,
    renderCell: (params) => {
      return <ProctorListMoreActionMenu id={params.row.id} />;
    },
  },
];
